module.exports = __webpack_public_path__ + "img/ch40.c22bcdaf.jpg";